import { render } from "./StockIn.vue?vue&type=template&id=5a24f9e8&scoped=true"
import script from "./StockIn.vue?vue&type=script&lang=js"
export * from "./StockIn.vue?vue&type=script&lang=js"

import "./StockIn.vue?vue&type=style&index=0&id=5a24f9e8&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a24f9e8"]])

export default __exports__